import "./PatientClinicalRecordCard.scss";
import { useEffect, useState } from "react";
import {
  ComboBox,
  DatePicker,
  Dropdown,
  IconButton,
  Label,
  SearchBox,
  TextField,
} from "@fluentui/react";

export interface ISmartInput {
  name: string;
  label: string;
  options?: { key: string; text: string }[];
  type: "text" | "date" | "auto" | "select" | "combo";
}

export interface IPatientClinicalRecordCardProps {
  sectionTitle: string;
  sourceData: string;
  sectionType: "default" | "table";
  sectionFields: ISmartInput[];
  emit: (data: any) => void;
}

const PatientClinicalRecordCard = (props: IPatientClinicalRecordCardProps) => {
  const [data, setData] = useState<any>(undefined);
  const [comboFilterMap, setComboFilterMap] = useState<any>({});

  const updateFilterMap = (name: string, value: any) => {
    if (value !== undefined) {
      let dt = { ...comboFilterMap };
      dt[name] = value.toLowerCase();
      setComboFilterMap(dt);
    }
  };

  const updateData = (name: string, value: any) => {
    if (value !== undefined) {
      let dt = { ...data };
      dt[name] = value;
      setData(dt);
      props.emit(dt);
    }
  };

  useEffect(() => {
    setData(props.sourceData);
  }, [props.sourceData]);

  const getComboOptions = (fullOptions: any[], inputName: string) => {
    let filter = comboFilterMap[inputName];
    let result = (fullOptions ?? []).filter(
      (x: any) => filter === undefined || x.text.toLowerCase().includes(filter)
    );
    return filter && filter.length > 3 ? result : [];
  };

  const getComboLabel = (fullOptions: any[], key: string) => {
    let result: any = (fullOptions ?? []).find((x: any) => x.key == key);
    return result ? result.text : undefined;
  };

  return (
    <div>
      {data !== undefined && (
        <div>
          <h2>{props.sectionTitle}</h2>
          {props.sectionType === "default" && (
            <div>
              {props.sectionFields.map((x: ISmartInput, i: number) => {
                return (
                  <div key={i}>
                    {x.type === "auto" && (
                      <div>
                        <Label>{x.label}</Label>
                        <div>{data[x.name]}</div>
                      </div>
                    )}
                    {x.type === "date" && (
                      <DatePicker
                        onSelectDate={(date: Date | null | undefined) => {
                          if (date) {
                            updateData(x.name, date.toISOString());
                          }
                        }}
                        placeholder={x.label}
                        label={x.label}
                        value={
                          data[x.name] ? new Date(data[x.name]) : undefined
                        }
                      />
                    )}
                    {x.type === "select" && (
                      <Dropdown
                        options={x.options ?? []}
                        onChange={(e, o) => {
                          if (o) {
                            updateData(x.name, o.key);
                          }
                        }}
                        placeholder={x.label}
                        label={x.label}
                        defaultSelectedKey={data[x.name]}
                      />
                    )}
                    {x.type === "combo" && (
                      <div>
                        <Label>{x.label}</Label>
                        {!data[x.name] && (
                          <div>
                            <SearchBox
                              placeholder={"Filtra risultati"}
                              onChange={(e, o) => {
                                updateFilterMap(x.name, o);
                              }}
                              onClear={() => {
                                updateFilterMap(x.name, "");
                              }}
                            />
                            <br />
                            {getComboOptions(x.options ?? [], x.name).map(
                              (y: { key: string; text: string }) => {
                                return (
                                  <div
                                    onClick={() => {
                                      updateData(x.name, y.key);
                                    }}
                                    key={i}
                                    className="patient-clinical-combo-option"
                                  >
                                    {y.text}
                                  </div>
                                );
                              }
                            )}
                          </div>
                        )}
                        {data[x.name] && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "1em",
                            }}
                          >
                            {getComboLabel(x.options ?? [], data[x.name])}{" "}
                            <IconButton
                              iconProps={{ iconName: "Cancel" }}
                              onClick={() => {
                                updateFilterMap(x.name, "");
                                updateData(x.name, null);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {x.type === "text" && (
                      <TextField
                        onChange={(e, o) => {
                          updateData(x.name, o);
                        }}
                        placeholder={x.label}
                        label={x.label}
                        defaultValue={data[x.name]}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PatientClinicalRecordCard;
